import { selectChangeMessageForStringArray } from '@newStore/documentUI/changeMessageSelectors/selectChangeMessageForStringArray';
import type { RootEditComponent } from '@nodeTypeConfig/configTypes';

export const proAliasesComponent: RootEditComponent = {
  component: 'subjects',
  property: 'subjects',
  reactComponent: 'AsideSubjects',
  label: 'Aliassen',
  asideChangeMessageSelector: selectChangeMessageForStringArray,
};
